module.exports = __webpack_public_path__ + "img/round.fd197b1e.svg";